const modal = document.getElementById("js-product-added");

if(modal && window.location.hash === "#added") {
    modal.classList.add("modal--open");
}